module.exports = __webpack_public_path__ + "img/logo.f22de089.png";